import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CleanerService } from '../../../../injections/cleaner.service';

@Component({
    selector: 'comment-detail',
    templateUrl: '../../templates/partials/comment.html'
})

export class CommentComponent implements OnInit {
    @Input() comment;
    @Input() index;
    @Output() updateCommentEmitter = new EventEmitter();
    public editComment = false;
    public commentCopy;
    constructor(cleanerService: CleanerService) { }

    public editCommentCleaner(edit: boolean){
        if(edit == true) this.commentCopy = Object.assign({}, this.comment);
        this.editComment = edit;
    }

    public updateCleanerComment(){
        this.editCommentCleaner(false);
        this.comment = this.commentCopy;
        this.updateCommentEmitter.emit({action:"update", data: this.commentCopy});
    }

    public deleteCommentCleaner() {
        
        this.updateCommentEmitter.emit({action:"delete", data: this.comment, index: this.index});
    }

    ngOnInit() {}
}


// WEBPACK FOOTER //
// ./src/app/modules/cleaners/components/dummy/comment.component.ts